import { toast } from "sonner";
import { Button } from "./ui/button";
import { trpc } from "../lib/trpc";

interface OrgSwitcherProps {
  orgs: Array<{ id: string; name: string }>;
  currentId: string | null;
}

/** Org buttons for users in more than one org; the current org is highlighted. */
export function OrgSwitcher({ orgs, currentId }: OrgSwitcherProps) {
  const switchOrg = trpc.auth.switchOrg.useMutation({
    // The session cookies rotated; a full reload refetches everything for the new org.
    onSuccess: () => window.location.reload(),
    onError: (error) => toast.error(error.message || "Failed to switch organization"),
  });

  if (orgs.length < 2) return null;

  return (
    <div role="group" aria-label="Organizations" className="flex items-center gap-1">
      {orgs.map((org) => {
        const current = org.id === currentId;
        return (
          <Button
            key={org.id}
            type="button"
            size="sm"
            variant={current ? "outline-brand" : "ghost"}
            aria-current={current ? "true" : undefined}
            disabled={switchOrg.isPending}
            onClick={() => {
              if (!current) switchOrg.mutate({ tenantId: org.id });
            }}
          >
            {org.name}
          </Button>
        );
      })}
    </div>
  );
}
